import { Injectable } from '@angular/core';

export interface EngagementDetails {
    engagementId: number;
    workflowId: number | null;
    clientId: number;
    clientName: string;
    clientMasterRefId: number | null;
    isFavoriteStudy: boolean;
    libraryId: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    private _engagementInfo: EngagementDetails | null = null;

    constructor() { }

    get engagementInfo(): EngagementDetails | null {
        return this._engagementInfo;
    }

    set engagementInfo(details: EngagementDetails | null) {
        this._engagementInfo = details;
    }

}